<template>
  <div>
    <v-progress-linear
      color="primary"
      :model-value="status ? progressDikeProfileCreation : null"
                       :indeterminate="status==null"></v-progress-linear>
    <div class="text-center" v-if="status"><small>
      Generating elevation profiles
      ({{ status.done }}/{{ status.total }})</small>
    </div>
    <div class="text-center" v-else><small>
      Preparing elevation model .tif to generate elevation profiles...
    </small>
    </div>
  </div>
</template>
<script>
import {mapState} from "vuex";

export default {
  name: 'GenerateElevationProfilesLoadingBar',
  computed: {
    ...mapState('dikeProfiles', {
      dikeProfiles: state => state.items,
    }),
    ...mapState('webSocket', {
      status: state => state.status,
    }),
    progressDikeProfileCreation() {
      return this.status ? this.status.done / this.status.total * 100 : null
    },
  },
}
</script>
